import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-compilation-icon',
  templateUrl: './files-compilation.component.html'
})
export class FilesCompilationComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
